<template>
  <div class="content">
    <!-- 封面图 -->
    <div
      class="main_title"
      :style="{
        'background-image': 'url(' + cover.cover_pc + ')',
      }"
    >
      <div style="margin: 0 auto; padding-top: 30px">
        <p class="display-4">麦卡赛编程</p>
        <p>—— McCarthy ——</p>
      </div>
    </div>
    <div class="contact_title">
      <div style="margin: 0 auto">
        <h2>联系我们</h2>
        <p>Contact us</p>
      </div>
    </div>
    <div class="main">
      <div class="contact-container">
        <div class="contact_item">
          <p class="contact_item_icon"><i class="fa fa-map-pin fa-3x"></i></p>
          <p class="contact_item_title">学校地址</p>
          <div class="contact_item_text">地址：{{ info.address }}</div>
        </div>
        <div class="contact_item">
          <p class="contact_item_icon"><i class="fa fa-phone fa-3x"></i></p>
          <p class="contact_item_title">联系电话</p>
          <div class="contact_item_text">电话：{{ info.tel }}</div>
        </div>
        <div class="contact_item">
          <p class="contact_item_icon"><i class="fa fa-wechat fa-3x"></i></p>
          <p class="contact_item_title">官方微信</p>
          <div class="contact_item_text">微信公众号：麦卡赛编程</div>
        </div>
      </div>
      <div
        id="mapcontainer"
        style="height: 400px; width: 100%; margin: 10px 0; border-radius: 5px"
      ></div>
    </div>
    <div class="main">
      <div class="contact_route">
        <h5 class="route_title">到麦卡赛的交通路线</h5>
        <div class="route_bus">
          <p class="route_t"><i class="fa fa-bus fa-2x"> </i> 公交</p>
          <p class="route_text">
            {{ info.bus }}
          </p>
        </div>
        <div class="route_gap"></div>
        <div class="route_metro">
          <p class="route_t"><i class="fa fa-subway fa-2x"> </i> 地铁</p>
          <p class="route_text">{{ info.metro }}</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { contact } from "@/api/api.js";
export default {
  data() {
    return {
      //封面图
      cover: {
        cover_pc: require("../assets/imgs/contact1.jpg"),
      },
      info: {}, //公司信息
    };
  },
  created() {
    //查询该页面内容
    this.fetchData();
  },
  methods: {
    fetchData() {
      contact().then((res) => {
        //信息
        this.info = res.data;
        this.map();
      });
    },
    map() {
      var map = new BMap.Map("mapcontainer"); // 创建地图实例
      var point = new BMap.Point(104.047179, 30.648312); // 创建点坐标
      map.centerAndZoom(point, 15);
      map.enableScrollWheelZoom(true);
      var marker = new BMap.Marker(point); // 创建标注
      map.addOverlay(marker); // 将标注添加到地图中
      var opts = {
        width: 100, // 信息窗口宽度
        height: 70, // 信息窗口高度
        title: "麦卡赛编程", // 信息窗口标题
      };
      var sContent = "地址：" + this.info.address + "；电话：" + this.info.tel;
      var infoWindow = new BMap.InfoWindow(sContent, opts); // 创建信息窗口对象
      map.openInfoWindow(infoWindow, map.getCenter()); // 打开信息窗口
    },
  },
};
</script>
<style scoped>
@import "../assets/css/common.css";
@import "../assets/css/font-awesome.min.css";

a:hover {
  text-decoration: none;
}

.main {
  max-width: 1200px;
  min-width: 1000px;
  margin: 0px auto 150px;
}
.main_title {
  background-position: center;
  background-repeat: no-repeat;
  color: #fff;
  height: 286px;
  margin-bottom: 50px;
  text-align: center;
}
.main_title .display-4 {
  font-size: 48px;
  font-weight: 300;
}
.contact_title {
  width: 100%;
  text-align: center;
}
.contact_title h2 {
  font-size: 36px;
  font-weight: 400;
}
.gap {
  clear: both;
}

.contact-container {
  width: 100%;
  display: -webkit-flex;
  display: flex;
  justify-content: space-between;
}
.contact_item {
  width: 330px;
  height: 250px;
  color: #666;
  text-align: center;
  padding: 50px 20px;
  margin: 10px;
}
/* .contact_item{
	display: inline-block;
	width: 30%;
	vertical-align: top;
	height: 250px;
	color: #666;
	padding: 50px 20px;
	margin: 10px;
} */
.contact_item:hover {
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
  color: #ffc200;
  font-size: 120%;
}

.contact_item_title {
  font-size: 18px;
  font-weight: bold;
}
.contact_item_text {
  font-size: 14px;
}
.contact_route {
  margin: 50px 0px;
}
.route_title {
  font-size: 18px;
  font-weight: bold;
  color: #666;
  padding-bottom: 20px;
}
.route_bus,
.route_metro {
  display: inline-block;
  vertical-align: top;
  width: 40%;
  color: #666;
}
.route_gap {
  display: inline-block;
  vertical-align: top;
  border: 0.5px dashed #ffc200;
  height: 50px;
  margin: 0 50px;
}
.route_bus > p > .fa,
.route_metro > p > .fa {
  color: #ffc200;
  padding-right: 10px;
}
.route_t {
  font-weight: bold;
}
.route_text {
  font-size: 15px;
}

</style>